import React from 'react';
import {
  Button,
  ButtonSize,
  ButtonColor,
} from 'ui-builder';
import MassUpdateControlsLayout from '../../../shared/widgets/MassUpdate/MassUpdateControlsLayout';
import { usePeopleMassDeleteUseCase, usePeopleMassAddToClientAppUseCase } from 'features/tasks-forms';
import { LinkToExternalContactsButton } from './LinkToExternalContactsButton';
import { ClientAppToggleWrapper } from 'feature-toggle';

export function DeleteButton() {
  const massDeleteLogic = usePeopleMassDeleteUseCase();

  return (
    <Button
      text="Delete"
      isDisabled={!massDeleteLogic.isButtonEnabled}
      isFlat
      isFilled
      size={ButtonSize.SMALL}
      color={ButtonColor.RED}
      onClick={async () => {
        massDeleteLogic.handleAction();
      }}
    />
  );
}

export function AddToClientAppButton() {
  const massAddToClientAppLogic = usePeopleMassAddToClientAppUseCase();

  return (
    <ClientAppToggleWrapper>
      <Button
        text="Add to Client App"
        isDisabled={!massAddToClientAppLogic.isButtonEnabled}
        isFlat
        isFilled
        size={ButtonSize.SMALL}
        color={ButtonColor.BLUE}
        onClick={async () => {
          massAddToClientAppLogic.handleAction();
        }}
      />
    </ClientAppToggleWrapper>
  );
}

export default function MassUpdateControls() {
  return (
    <MassUpdateControlsLayout>
      <LinkToExternalContactsButton />
      <AddToClientAppButton />
      <DeleteButton />
    </MassUpdateControlsLayout>
  );
}
